"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatsCard = StatsCard;
var _CardContent2 = _interopRequireDefault(require("@mui/material/CardContent"));
var _Card2 = _interopRequireDefault(require("@mui/material/Card"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Grid2 = _interopRequireDefault(require("@mui/material/Grid"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Skeleton2 = _interopRequireDefault(require("@mui/material/Skeleton"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = require("styled-components");
var _environment = require("../environment");
var _hooks = require("../hooks");
var _icons = require("./icons");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function StatsCard({
  showDistance,
  showElevationGain,
  showSteps,
  hideCalories,
  hideCO2Saved,
  hideDuration,
  enableDays,
  data
}) {
  const {
    toDistance,
    toTime
  } = (0, _hooks.useUnits)();
  return /*#__PURE__*/_react.default.createElement(_Card2.default, {
    sx: {
      borderRadius: 2
    },
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(StyledCardContent, null, /*#__PURE__*/_react.default.createElement(_Grid2.default, {
    container: true,
    spacing: 4,
    sx: {
      width: '100%'
    }
  }, showDistance && /*#__PURE__*/_react.default.createElement(_Grid2.default, {
    size: 6
  }, /*#__PURE__*/_react.default.createElement(StyledGridContent, null, /*#__PURE__*/_react.default.createElement(_icons.DistanceIcon, {
    color: data ? 'primary' : 'action'
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    noWrap: true,
    component: "div",
    variant: "subtitle1"
  }, data ? toDistance(data.distance) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 100
  })))), showElevationGain && (!data || data.verticalGain !== undefined) && /*#__PURE__*/_react.default.createElement(_Grid2.default, {
    size: 6
  }, /*#__PURE__*/_react.default.createElement(StyledGridContent, null, /*#__PURE__*/_react.default.createElement(_icons.VerticalGainIcon, {
    color: data ? 'primary' : 'action'
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    noWrap: true,
    component: "div",
    variant: "subtitle1"
  }, data ? toDistance(data.verticalGain || 0) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 100
  })))), showSteps && /*#__PURE__*/_react.default.createElement(_Grid2.default, {
    size: 6
  }, /*#__PURE__*/_react.default.createElement(StyledGridContent, null, /*#__PURE__*/_react.default.createElement(_icons.FlagIcon, {
    color: data ? 'primary' : 'action'
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    noWrap: true,
    component: "div",
    variant: "subtitle1"
  }, data ? /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    count: data.nbSteps || 0,
    i18nKey: "geovelo.trip.steps",
    values: {
      count: data.nbSteps || 0
    }
  }) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 100
  })))), !hideDuration && /*#__PURE__*/_react.default.createElement(_Grid2.default, {
    size: 6
  }, /*#__PURE__*/_react.default.createElement(StyledGridContent, null, /*#__PURE__*/_react.default.createElement(_icons.DurationIcon, {
    color: data ? 'primary' : 'action'
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    noWrap: true,
    component: "div",
    variant: "subtitle1"
  }, data ? enableDays ? /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    count: data.duration,
    i18nKey: "commons.day",
    values: {
      count: data.duration
    }
  }) : toTime(data.duration) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 100
  })))), !hideCalories && /*#__PURE__*/_react.default.createElement(_Grid2.default, {
    size: 6
  }, /*#__PURE__*/_react.default.createElement(StyledGridContent, null, /*#__PURE__*/_react.default.createElement(_icons.CaloriesIcon, {
    color: data ? 'primary' : 'action'
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    noWrap: true,
    component: "div",
    variant: "subtitle1"
  }, data ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, Math.round((data.calories || 0) / 1000), " kcal") : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 100
  })))), !hideCO2Saved && /*#__PURE__*/_react.default.createElement(_Grid2.default, {
    size: 6
  }, /*#__PURE__*/_react.default.createElement(StyledGridContent, null, /*#__PURE__*/_react.default.createElement(_icons.SavedCO2Icon, {
    color: data ? 'primary' : 'action'
  }), /*#__PURE__*/_react.default.createElement(_Box2.default, null, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    noWrap: true,
    component: "div",
    variant: "subtitle1"
  }, data ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (data.distance / 1000 * _environment.defaultEnvironment.savedKgOfCO2PerKilometer).toFixed(1), ' ', "kg") : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 100
  })), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    noWrap: true,
    color: "textSecondary",
    variant: "body2"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.routing.detail.co2_saved"
  }))))))));
}
const StyledCardContent = (0, _styledComponents.styled)(_CardContent2.default)`
  && {
    padding: 24px;
  }
`;
const StyledGridContent = _styledComponents.styled.div`
  align-items: center;
  display: flex;

  svg {
    flex-shrink: 0;
    margin-right: 16px;
  }
`;